/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shareButtonDialogue.vue?vue&type=template&id=8c522f96&scoped=true"
import script from "./shareButtonDialogue.vue?vue&type=script&lang=js"
export * from "./shareButtonDialogue.vue?vue&type=script&lang=js"
import style0 from "./shareButtonDialogue.vue?vue&type=style&index=0&id=8c522f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c522f96",
  null
  
)

export default component.exports